import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { useSearchBoxContext } from "@/components/Search/SearchBar/components/SearchBox/context/searchBox.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Form = ({ className, children }: Props) => {
    const { formRef, formProps } = useSearchBoxContext();

    return (
        <form
            {...formProps}
            className={cn(className)}
            ref={formRef}
        >
            {children}
        </form>
    );
};
